export const INSURANCE_TYPES = {
  HEALTH_INSURANCE: 'HEALTH_INSURANCE',
  LIFE_INSURANCE: 'LIFE_INSURANCE',
  AUTO_INSURANCE: 'AUTO_INSURANCE',
  HOMEOWNERS_INSURANCE: 'HOMEOWNERS_INSURANCE',
  BUSINESS_INSURANCE: 'BUSINESS_INSURANCE',
  TRAVEL_INSURANCE: 'TRAVEL_INSURANCE',
  INVESTMENT_INSURANCE: 'INVESTMENT_INSURANCE',
  PERSONAL_ACCIDENT_INSURANCE: 'PERSONAL_ACCIDENT_INSURANCE',
  LIABILITY_INSURANCE: 'LIABILITY_INSURANCE',
  PET_INSURANCE: 'PET_INSURANCE',
  AHORRO: 'AHORRO',
  INVERSION: 'INVERSION',
};
export const LEAD_INSURANCE_TYPES = {
  ...INSURANCE_TYPES,
};
// A lead's insurance type is either a built-in key or the id of one of the provider's custom types.
export const isBuiltInLeadInsuranceType = (value) => (
  Object.prototype.hasOwnProperty.call(LEAD_INSURANCE_TYPES, value)
);
// Sales-goal group of a lead's product. It picks the goal bucket, the deal-premium label and whether
// the payment format applies. A custom type carries its own group; among built-ins only AHORRO and
// INVERSION have one, everything else is COMMON (mirrors the backend's LeadInsuranceGroup).
export const LEAD_INSURANCE_GOAL_GROUPS = {
  COMMON: 'COMMON',
  AHORRO: 'AHORRO',
  INVERSION: 'INVERSION',
};
export function leadInsuranceGoalGroup(insuranceType, customInsuranceType = null) {
  if (customInsuranceType && LEAD_INSURANCE_GOAL_GROUPS[customInsuranceType.goalGroup]) {
    return customInsuranceType.goalGroup;
  }
  if (insuranceType === INSURANCE_TYPES.AHORRO || insuranceType === INSURANCE_TYPES.INVERSION) {
    return insuranceType;
  }
  return LEAD_INSURANCE_GOAL_GROUPS.COMMON;
}
export const PLAN_TYPES = {
  // FINANCIAL: 'FINANCIAL',
  CORPORATE: 'CORPORATE',
  INDIVIDUAL: 'INDIVIDUAL',
};
export const PLAN_TYPES_NAMES = {
  [PLAN_TYPES.CORPORATE]: 'adminTitles.GroupPlan',
  [PLAN_TYPES.INDIVIDUAL]: 'adminTitles.IndividualPlan',
};
export const INSURANCE_TYPES_NAMES = {
  [INSURANCE_TYPES.HEALTH_INSURANCE]: 'programTypes.HEALTH_INSURANCE',
  [INSURANCE_TYPES.LIFE_INSURANCE]: 'programTypes.LIFE_INSURANCE',
  [INSURANCE_TYPES.AUTO_INSURANCE]: 'programTypes.AUTO_INSURANCE',
  [INSURANCE_TYPES.HOMEOWNERS_INSURANCE]: 'programTypes.HOMEOWNERS_INSURANCE',
  [INSURANCE_TYPES.BUSINESS_INSURANCE]: 'programTypes.BUSINESS_INSURANCE',
  [INSURANCE_TYPES.TRAVEL_INSURANCE]: 'programTypes.TRAVEL_INSURANCE',
  [INSURANCE_TYPES.INVESTMENT_INSURANCE]: 'programTypes.INVESTMENT_INSURANCE',
  [INSURANCE_TYPES.PERSONAL_ACCIDENT_INSURANCE]: 'programTypes.PERSONAL_ACCIDENT_INSURANCE',
  [INSURANCE_TYPES.LIABILITY_INSURANCE]: 'programTypes.LIABILITY_INSURANCE',
  [INSURANCE_TYPES.PET_INSURANCE]: 'programTypes.PET_INSURANCE',
  [INSURANCE_TYPES.AHORRO]: 'programTypes.AHORRO',
  [INSURANCE_TYPES.INVERSION]: 'programTypes.INVERSION',
};
export const PlanTypeOptions = {
  data() {
    return {
      INSURANCE_TYPES_OPTIONS: [
        {
          id: INSURANCE_TYPES.HEALTH_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.HEALTH_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.LIFE_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.LIFE_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.AUTO_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.AUTO_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.HOMEOWNERS_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.HOMEOWNERS_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.BUSINESS_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.BUSINESS_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.TRAVEL_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.TRAVEL_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.INVESTMENT_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.INVESTMENT_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.PERSONAL_ACCIDENT_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.PERSONAL_ACCIDENT_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.LIABILITY_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.LIABILITY_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.PET_INSURANCE,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.PET_INSURANCE])
        },
        {
          id: INSURANCE_TYPES.AHORRO,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.AHORRO])
        },
        {
          id: INSURANCE_TYPES.INVERSION,
          name: this.$t(INSURANCE_TYPES_NAMES[INSURANCE_TYPES.INVERSION])
        },
      ],
      LEAD_INSURANCE_TYPES_OPTIONS: Object.values(LEAD_INSURANCE_TYPES).map((id) => ({
        id,
        name: this.$t(INSURANCE_TYPES_NAMES[id]),
      })),
      PLAN_TYPES_OPTIONS: [
        {
          id: PLAN_TYPES.CORPORATE,
          name: this.$t(PLAN_TYPES_NAMES[PLAN_TYPES.CORPORATE])
        },
        {
          id: PLAN_TYPES.INDIVIDUAL,
          name: this.$t(PLAN_TYPES_NAMES[PLAN_TYPES.INDIVIDUAL])
        },
      ],
    };
  },
  methods: {
    // Policy/program type options gated by the provider flag: providers
    // without investmentInsuranceEnabled cannot create INVESTMENT_INSURANCE
    // records. Pass the type already saved on the record being edited as
    // `currentTypeId` so existing investment policies stay editable.
    policyTypeOptionsForProvider(currentTypeId = null) {
      const enabled = !!this.$store?.getters?.selectedInsuranceProviderDetails?.investmentInsuranceEnabled;
      return this.INSURANCE_TYPES_OPTIONS.filter(
        (o) => o.id !== INSURANCE_TYPES.INVESTMENT_INSURANCE || enabled || o.id === currentTypeId,
      );
    },
  },
};
